var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSubmissionBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_3230)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3121_3230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 17,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8434 0.687256H1.42188V20.05H17.8434V17.667H17.5767V19.667H12.6367V17.667H6.32324V16.6875H4.50977V1.6875H14.5098V10.667H17.8434V0.687256Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3121_3230)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3121_3230",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.8916,
    y: 3.62805,
    width: 13.2353,
    height: 15,
    rx: 0.980392
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.8916,
    y: 3.62805,
    width: 13.2353,
    height: 15,
    rx: 0.980392,
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_3121_3230)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9591 2.89258L10.466 2.97527L10.536 3.39258H10.9591V2.89258ZM13.5088 4.89258V5.39258H14.0088V4.89258H13.5088ZM5.50879 4.89258H5.00879V5.39258H5.50879V4.89258ZM8.05857 2.89258V3.39258H8.4817L8.55168 2.97527L8.05857 2.89258ZM10.9591 3.39258H12.1755V2.39258H10.9591V3.39258ZM12.1755 3.39258C12.6357 3.39258 13.0088 3.76567 13.0088 4.22591H14.0088C14.0088 3.21339 13.188 2.39258 12.1755 2.39258V3.39258ZM13.0088 4.22591V4.89258H14.0088V4.22591H13.0088ZM13.5088 4.39258H5.50879V5.39258H13.5088V4.39258ZM6.00879 4.89258V4.22591H5.00879V4.89258H6.00879ZM6.00879 4.22591C6.00879 3.76567 6.38189 3.39258 6.84212 3.39258V2.39258C5.8296 2.39258 5.00879 3.21339 5.00879 4.22591H6.00879ZM6.84212 3.39258H8.05857V2.39258H6.84212V3.39258ZM8.55168 2.97527C8.6286 2.51658 9.02839 2.16699 9.50884 2.16699V1.16699C8.53187 1.16699 7.72182 1.87745 7.56545 2.80988L8.55168 2.97527ZM9.50884 2.16699C9.98929 2.16699 10.3891 2.51658 10.466 2.97527L11.4522 2.80988C11.2959 1.87745 10.4858 1.16699 9.50884 1.16699V2.16699Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66602 6.66699H6.66602V7.66699H5.66602V6.66699ZM7.13656 6.66699H13.1366V7.66699H7.13656V6.66699ZM7.13656 8.66699H13.1366V9.66672H7.13656V8.66699ZM5.66602 8.6672H6.66602V9.66692H5.66602V8.6672Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6076 14.9032C18.7636 14.7844 18.7636 14.5496 18.6076 14.4308L13.7484 10.7283C13.553 10.5793 13.2715 10.7187 13.2715 10.9645L13.2715 12.9305H9.47754V16.1615H13.2715L13.2715 18.3695C13.2715 18.6152 13.553 18.7546 13.7484 18.6057L18.6076 14.9032Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_3230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.67,
    height: 20,
    fill: "white",
    transform: "translate(1.66602 0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubmissionBlack);
export default __webpack_public_path__ + "static/media/icon_submission_black.c5d898b6f4a9b7bcece8182253948f73.svg";
export { ForwardRef as ReactComponent };